export type BuildP2PSessionCreateBodyParams = {
	patientId: string;
	selectedDate: string;
	isOnline: boolean;
	/** Obrigatório para Admin/Support; omitido quando o profissional está autenticado. */
	professionalId?: string;
	serviceId?: string;
	availableDateId?: string;
	bypassScheduleConstraints?: boolean;
};

export type BuildP2PTranscriptionOnlySessionCreateBodyParams = Omit<
	BuildP2PSessionCreateBodyParams,
	'isOnline'
>;

export type BuildP2PSessionPatchDateBodyParams = {
	selectedDate: string;
	availableDateId?: string;
	bypassScheduleConstraints?: boolean;
};

/** Body para POST /session com type P2P (profissional ou admin). */
export const buildP2PSessionCreateBody = (
	params: BuildP2PSessionCreateBodyParams,
): Sessions.Create => ({
	type: 'P2P',
	patient_id: params.patientId,
	selected_date: params.selectedDate,
	is_online: params.isOnline,
	bypass_schedule_constraints: params.bypassScheduleConstraints ?? true,
	...(params.professionalId
		? { professional_id: params.professionalId }
		: {}),
	...(params.serviceId ? { service_id: params.serviceId } : {}),
	...(params.availableDateId
		? { available_date_id: params.availableDateId }
		: {}),
});

/** Body para POST /session com type P2P_TRANSCRIPTION_ONLY. */
export const buildP2PTranscriptionOnlySessionCreateBody = (
	params: BuildP2PTranscriptionOnlySessionCreateBodyParams,
): Sessions.Create => ({
	type: 'P2P_TRANSCRIPTION_ONLY',
	patient_id: params.patientId,
	selected_date: params.selectedDate,
	bypass_schedule_constraints: params.bypassScheduleConstraints ?? true,
	...(params.professionalId
		? { professional_id: params.professionalId }
		: {}),
	...(params.serviceId ? { service_id: params.serviceId } : {}),
	...(params.availableDateId
		? { available_date_id: params.availableDateId }
		: {}),
});

/** Body para PATCH /session/:id/date em consultas P2P. */
export const buildP2PSessionPatchDateBody = (
	params: BuildP2PSessionPatchDateBodyParams,
): Sessions.PatchDate['body'] => ({
	selected_date: params.selectedDate,
	bypass_schedule_constraints: params.bypassScheduleConstraints ?? true,
	...(params.availableDateId
		? { available_date_id: params.availableDateId }
		: {}),
});
